// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconContactlessPath = 'M16.842.906 16.386 0 14.58.917l.457.907.218.449a18.201 18.201 0 0 1-.218 15.903l-.457.907 1.805.917.456-.906.23-.472a20.24 20.24 0 0 0-.23-17.716ZM12.335 3.07l-.466-.902-1.795.935.465.902.184.372A13.086 13.086 0 0 1 11.99 10c.001 2.09-.497 4.147-1.45 5.996l-.465.902 1.795.935.466-.902.2-.404A15.125 15.125 0 0 0 14.012 10c0-2.414-.575-4.793-1.678-6.93ZM7.33 4.332l.484.892a9.996 9.996 0 0 1 1.208 4.775 10.002 10.002 0 0 1-1.032 4.436l-.176.34-.484.893-1.776-.973.485-.892A7.96 7.96 0 0 0 7 9.999a7.963 7.963 0 0 0-.81-3.508l-.151-.294-.485-.892 1.776-.973ZM3.245 7.338l-.555-.85L1 7.606l.555.849.106.175c.23.416.352.888.352 1.37 0 .553-.159 1.09-.458 1.547L1 12.395l1.69 1.116.555-.849.148-.24c.42-.735.643-1.571.642-2.424a4.852 4.852 0 0 0-.79-2.66Z';
var IconContactless = baseIcon('IconContactless', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconContactlessPath
});
export default IconContactless;
//# sourceMappingURL=index.js.map